import React from "react"
import LogoMrp from "../../assets/images/logo_mrp.png"

const DevelopedByMrp = () => {
  return (
    <div
      style={{
        display: "flex",
        alignItems: "center",
        justifyContent: "flex-end",
        width: "100vw",
        position: "absolute",
        bottom: "1%",
        gap: "4px",
        marginRight: "3%",
      }}
    >
      <p
        style={{
          color: "#FFFFFF",
          fontSize: "11px",
          fontWeight: 400,
          margin: 0,
        }}
      >
        Desenvolvido por
      </p>
      <img src={LogoMrp} alt="MRP Logo" style={{}} />
    </div>
  )
}

export default DevelopedByMrp
